/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Layout_WrapInputs */

const cs_pipelines_layout_wrap = /** @type {(inputs: Pipelines_Layout_WrapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Více řádků`)
};

const en_pipelines_layout_wrap = /** @type {(inputs: Pipelines_Layout_WrapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiple rows`)
};

/**
* | output |
* | --- |
* | "Multiple rows" |
*
* @param {Pipelines_Layout_WrapInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_layout_wrap = /** @type {((inputs?: Pipelines_Layout_WrapInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Layout_WrapInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_layout_wrap(inputs)
	return cs_pipelines_layout_wrap(inputs)
});